module.exports = __webpack_public_path__ + "img/ai_geptM.66faf696.png";